import { WCAG_ENABLED } from '../../config';
import React from 'react';
import PropTypes from 'prop-types';

// Return WCAG compatible semantic element or legacy implementation based on WCAG_ENABLED config.

function AdaptiveButton(props) {
  const { disabled, forwardedRef, ...rest } = props;

  return WCAG_ENABLED ? (
    <button type="button" tabIndex={0} disabled={disabled} {...rest} ref={forwardedRef} />
  ) : (
    <div role="button" tabIndex={0} {...rest} ref={forwardedRef} />
  );
}

AdaptiveButton.propTypes = {
  'aria-disabled': PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-pressed': PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  forwardedRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  id: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
  tabIndex: PropTypes.number,
  type: PropTypes.string,
  value: PropTypes.string,
};

const AdaptiveButtonWithRef = React.forwardRef((props, ref) => <AdaptiveButton {...props} forwardedRef={ref} />);

function AdaptiveMain(props) {
  const { forwardedRef, ...rest } = props;
  return WCAG_ENABLED ? <main {...rest} ref={forwardedRef} /> : <div role="main" {...rest} ref={forwardedRef} />;
}

AdaptiveMain.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  forwardedRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
};

const AdaptiveMainWithRef = React.forwardRef((props, ref) => <AdaptiveMain {...props} forwardedRef={ref} />);

function AdaptiveHeader(props) {
  return WCAG_ENABLED ? <header {...props} /> : <div {...props} aria-roledescription="header" />;
}

AdaptiveHeader.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

function AdaptiveFooter(props) {
  return WCAG_ENABLED ? <footer {...props} /> : <div {...props} aria-roledescription="footer" />;
}

AdaptiveFooter.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export { AdaptiveButton, AdaptiveMain, AdaptiveMainWithRef, AdaptiveHeader, AdaptiveFooter, AdaptiveButtonWithRef };
